import { IAuthUser } from 'auth/types';
import { AccessPermissions } from 'core/enums';
import { hasPermission } from 'router/utils';

// Single rule for the Company Settings surface (menu item + pages): mirrors V1, where the header
// item is shown only to company admins and the pages sit behind the company-settings resource.
export const canAccessCompanySettings = (user?: IAuthUser | null): boolean =>
  Boolean(user?.companyAdmin) &&
  hasPermission([AccessPermissions.COMPANY_SETTINGS], user?.resources ?? []);

// The Part Finder setup pages live inside Company Settings and also need their own resource,
// which company admins are not granted by default.
export const canAccessPartFinderSetup = (user?: IAuthUser | null): boolean =>
  canAccessCompanySettings(user) &&
  hasPermission([AccessPermissions.ACCESS_PART_FINDER_SETUP], user?.resources ?? []);
